import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { fetchIndustries } from '../../backend/industries';
import { Industry } from '../../../data_types';
import './IndustryDetails2.css'; // Import the CSS file

const IndustryDetails2: React.FC = () => {
    const { displayId } = useParams<{ displayId: string }>();
    const [industry, setIndustry] = useState<Industry | null>(null);
    const [readTime, setReadTime] = useState<number>();

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadIndustry = async () => {
            try {
                const data = await fetchIndustries();
                const foundIndustry = data.industries.find(industry => industry.displayId === (displayId ? parseInt(displayId) : NaN));
                if (foundIndustry) {
                    setIndustry(foundIndustry);
                    setReadTime(Math.ceil(foundIndustry.industryDescription.length / 1000));
                } else {
                    console.error('Industry not found');
                }
            } catch (error) {
                console.error('Failed to fetch industry details', error);
            }
        };

        loadIndustry();
    }, [displayId]);

    if (!industry) {
        return <Typography variant="h6" color="error">Industry not found</Typography>;
    }

    return (
        <Box className='industry-container'>
            <Box className='main'>
                <Box className="overlay" />
                <img
                    src={`${process.env.REACT_APP_STATIC_FILE_ROUTE}/${industry.imageUrl}`} // Change videoUrl to imageUrl as needed
                    alt={industry.industryTitle}
                    className="industry-image"
                    onError={() => console.log("Error loading image at", `${process.env.REACT_APP_STATIC_FILE_ROUTE}/${industry.imageUrl}`)}
                />
                <Box className="industry-title-container" sx={{ 
                    fontSize: { xs: '30px', sm: '36px', md: '42px', lg: '48px' },
                    padding: { xs: '20px', sm: '40px', md: '60px', lg: '80px' },
                }}>
                    <Box className="section-breadcrumb" id="industry-section-breadcrumb" sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px', lg: '16px' } }}>
                        INDUSTRIES
                    </Box>
                    {industry.industryTitle}
                </Box>
            </Box>

            {/* Content section below the image */}
            <Box
                className="content"
                sx={{
                    fontSize: { xs: '16px', sm: '21px', md: '27px', lg: '32px' },
                    px: { xs: '50px', sm: '100px', md: '150px', lg: '200px' },
                    py: '30px'
                }}
            >

                <Box className="industry-content">
                    <Box className="industry-content-container">
                        <Box dangerouslySetInnerHTML={{ __html: industry.industryDescription }} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default IndustryDetails2;
